import React, { useMemo } from 'react'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import TableWithSections from '../tables/TableWithSections'
import getTeamIdsAsFields from '../utils/getTeamIdsAsFields'
import getTeamName from '../utils/getTeamName'
import pluckResultsByType from '../utils/pluckResultsByType'

interface Props {
  configuration: ModelAPI.ConfigurationResponse
  data: ModelAPI.DecisionsResponse['specialProjects']
  teams: API.GameConnection[]
}

const SpecialProjects: React.FC<Props> = ({ configuration, data, teams }) => {
  const { numberOfTeams, numberOfCpuTeams } = configuration
  const totalNumberOfTeams = numberOfTeams + numberOfCpuTeams
  const fields = useMemo(() => getTeamIdsAsFields(totalNumberOfTeams), [totalNumberOfTeams])

  return (<>
    <VerticalGroup className='mt-2' spaceBetweenElements={2} wide>
      <TableWithSections
        header='Special Projects'
        data={[{
          fields,
          values: pluckResultsByType(data, 'specialProjects')
        }]}
        fieldFormatter={(field: string) => getTeamName(parseInt(field), numberOfTeams, teams)}
        formatter={(value: any) => {
          if (value == null) {
            return '-'
          }
          let returnVal = value.name.replace(/Project /, '')

          if (value.selectedProduct != null) {
            returnVal += `\n (${value.selectedProduct.name})`
          }
          return returnVal
        }}
      />
    </VerticalGroup>
  </>)
}

export default SpecialProjects